import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  ServiceMarketplaceDto,
  ServiceMarketplaceTranslationDto,
} from "@green0meter/api-client";

import ServiceDescription from "./components/ServiceDescription";
import ServiceGallery from "./components/ServiceGallery";
import ServiceActions from "./components/ServiceActions";
import Description from "./components/Description";

import { Grid } from "@components/base";

interface ServiceDetailsProps {
  service: ServiceMarketplaceDto;
}

const ServiceDetails: React.FC<ServiceDetailsProps> = ({ service }) => {
  const { i18n } = useTranslation();
  const [content, setContent] = useState<ServiceMarketplaceTranslationDto>();

  useEffect(() => {
    const currentLocale = i18n.language;

    let translation = service.translations?.find(
      (trans) => trans.languages_code === currentLocale,
    );

    if (!translation) {
      const languageCode = currentLocale.split("-")[0];

      translation = service.translations?.find((trans) =>
        trans.languages_code.startsWith(languageCode),
      );
    }

    if (!translation && service.translations?.length > 0) {
      translation = service.translations[0];
    }

    setContent(translation);
  }, [i18n.language, service]);

  if (!content) return null;

  const { title, description, service_description } = content;

  return (
    <Grid container spacing={3}>
      <Grid size={12}>
        <ServiceActions service={service} />
      </Grid>
      <Grid size={{ xs: 12, md: 12 }}>
        <Description title={title} description={description} />
      </Grid>
      <Grid size={{ xs: 12, md: 12 }}>
        <ServiceDescription serviceDescription={service_description} service={service} />
      </Grid>
      <Grid size={12}>
        <ServiceGallery gallery={service.gallery} />
      </Grid>
    </Grid>
  );
};

export default ServiceDetails;
